import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const NewsletterListPage = () =>
  import('@modules/newsletter/components/newsletter-list-page.vue');
const NewsletterFormPage = () =>
  import('@modules/newsletter/components/newsletter-form-page.vue');
const NewsletterViewPage = () =>
  import('@modules/newsletter/components/newsletter-view-page.vue');
const NewsletterImporterPage = () =>
  import('@modules/newsletter/components/newsletter-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'newsletter',
        path: '/newsletter',
        component: NewsletterListPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsletterView,
        },
      },
      {
        name: 'newsletterNew',
        path: '/newsletter/new',
        component: NewsletterFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsletterCreate,
        },
      },
      {
        name: 'newsletterImporter',
        path: '/newsletter/import',
        component: NewsletterImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsletterImport,
        },
      },
      {
        name: 'newsletterEdit',
        path: '/newsletter/:id/edit',
        component: NewsletterFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsletterEdit,
        },
        props: true,
      },
      {
        name: 'newsletterView',
        path: '/newsletter/:id',
        component: NewsletterViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsletterView,
        },
        props: true,
      },
    ],
  },
];
